import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  DialogContent,
  Grid,
  IconButton,
  Modal,
  TextField,
} from "@mui/material";
import { postJsonData } from "../../network/ApiController";
import ApiEndpoints from "../../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import ModalHeader from "../../modals/ModalHeader";
import ModalFooter from "../../modals/ModalFooter";
import EditIcon from "@mui/icons-material/Edit";
import { whiteColor } from "../../theme/setThemeColor";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  boxShadow: 24,
  fontFamily: "Poppins",
  p: 2,
  height: "max-content",
};

const EditSalary = ({ salary, onSuccess }) => {
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState(salary?.amount || "");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) setAmount(salary?.amount || "");
  }, [open, salary]);

  const handleSubmit = () => {
    if (!amount) {
      apiErrorToast("Please enter a valid amount");
      return;
    }

    setLoading(true);

    postJsonData(
      `${ApiEndpoints.EDIT_SALARY}`, // PUT/POST endpoint
      { amount, id: salary?.id },
      setLoading,
      (response) => {
        if (response?.data?.status === "success") {
          okSuccessToast(response.data.message);
          setOpen(false);
          if (onSuccess) onSuccess();
        } else {
          apiErrorToast(response?.data?.message || "Failed to update salary");
        }
      },
      (error) => {
        apiErrorToast(error?.message || "Error updating salary");
      }
    );
  };

  return (
    <>
      <IconButton
        sx={{ color: "#0F52BA" }}
        onClick={() => setOpen(true)}
        size="small"
      >
        <EditIcon />
      </IconButton>

      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={style} className="sm_modal">
          <ModalHeader title="Edit Salary" handleClose={() => setOpen(false)} />
          <DialogContent>
            <Grid container spacing={2} mt={1}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Amount"
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <ModalFooter btn="Update" request={loading} onClick={handleSubmit} />
        </Box>
      </Modal>
    </>
  );
};

export default EditSalary;
